import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@material-ui/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Input } from '~/components/Form';
import { signInRequest } from '~/store/modules/auth/actions';
import { toggleDrawer } from '~/store/modules/drawer/actions';

const schema = Yup.object().shape({
  username: Yup.string().required(),
  password: Yup.string().required(),
});

export default function SignIn() {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  async function handleSubmit({ username, password }) {
    const domain = window.location.hostname.split('.')[0];
    dispatch(signInRequest(domain, username, password));
  }

  window.addEventListener('resize', () => {
    setInnerWidth(window.innerWidth);
  });

  useEffect(() => {
    dispatch(toggleDrawer(innerWidth > 425));
  }, [innerWidth]);

  return (
    <Form schema={schema} onSubmit={handleSubmit}>
      <Input
        name="username"
        label="Nome de usuario"
        required
        variant="standard"
        size="medium"
      />

      <Input
        type="password"
        name="password"
        label="Senha"
        required
        variant="standard"
        size="medium"
      />

      <Button
        color="primary"
        variant="contained"
        fullWidth
        type="submit"
        disabled={loading}
      >
        {loading ? 'Carregando...' : 'Login'}
      </Button>
    </Form>
  );
}
